import * as Colors from 'HubStyleTokens/colors';
export let ColorThemeOption;
(function (ColorThemeOption) {
  ColorThemeOption["OrangeLight"] = "ORANGE_LIGHT";
  ColorThemeOption["YellowLight"] = "YELLOW_LIGHT";
})(ColorThemeOption || (ColorThemeOption = {}));
export const defaultColorOptions = {
  innerBlobColor: Colors.MARIGOLD_MEDIUM,
  outerBlobColor: Colors.MARIGOLD_LIGHT,
  smallDecorativeBlobColor: Colors.MARIGOLD
};
export const ColorTheme = new Map([[ColorThemeOption.OrangeLight, {
  innerBlobColor: Colors.SORBET_MEDIUM,
  outerBlobColor: Colors.SORBET_LIGHT,
  smallDecorativeBlobColor: Colors.SORBET
}], [ColorThemeOption.YellowLight, {
  innerBlobColor: Colors.MARIGOLD_MEDIUM,
  outerBlobColor: Colors.MARIGOLD_LIGHT,
  smallDecorativeBlobColor: Colors.MARIGOLD
}]]);